import { actions } from './actions';
import { mutations } from './mutations';
var state = {
    adAccounts: [],
};
export var adAccounts = {
    namespaced: true,
    state: state,
    actions: actions,
    mutations: mutations,
};
